import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useVerifyEmailMutation } from '@src/features/auth/redux';
import { routesConfig } from '@src/core/routes';
import { IVerifyEmailForm } from '@src/features/auth/pages/verify-email-page/types';

export const useVerifyEmailForm = () => {
  const navigate = useNavigate();
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const form = useForm<IVerifyEmailForm>();

  const onSubmit = async (data: IVerifyEmailForm) => {
    verifyEmail(data).unwrap()
      .then(() => {
        navigate(routesConfig.verifySuccess, { replace: true });
      })
      .catch(() => {});
  };

  return {
    ...form,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
  };
};

